import script from "./PublicationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicationCard.vue?vue&type=script&setup=true&lang=js"

import "./PublicationCard.vue?vue&type=style&index=0&id=29124858&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29124858"]])

export default __exports__